import { render, staticRenderFns } from "./OurWorks.vue?vue&type=template&id=dbb24160&"
import script from "./OurWorks.vue?vue&type=script&lang=js&"
export * from "./OurWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports